import React from "react";
import { leaf } from "../../assets";
import { useNavigate } from "react-router-dom";
import { urlFor } from "../../client";

const SeminarCard = ({ seminar, setSingleSeminar }) => {
  const navigation = useNavigate();

  const handleFunc = () => {
    setSingleSeminar(seminar);
    navigation("/single-seminar");
  };

  return (
    <div className="seminarCard">
      <div className="left">
        <img src={urlFor(seminar.seminarimg)} alt="" className="banner" />
      </div>
      <div className="right">
        <img src={leaf} alt="" className="img" />
        <small>{seminar.dop}</small>
        <h1>{seminar.title}.</h1>
        <p>{seminar.shortDesc}</p>

        <button onClick={() => handleFunc()}>View details</button>
      </div>
    </div>
  );
};

export default SeminarCard;
